/* eslint-disable import/no-unresolved */
import {
    Modal, ModalHeader, ModalBody, Select, SelectOption, Button,
    Switch,
} from 'appkit-react';
import { Row, Col } from 'react-bootstrap';

import Loader from 'views/Shared/components/Loader';
import AddFilesModal from './AddFilesModal';

import '../styles/dataSourceModal.scss';

const containerStyle = { display: 'flex', alignItems: 'center' };

const getBatchSelectOptions = (batchId, startDate, submitter) => (
    <div style={containerStyle}>
        Batch Id:
        <span style={{ fontWeight: 500, marginLeft: '0.2rem', marginRight: '0.2rem' }}>
            {batchId}
        </span>
        ran on
        <span style={{ fontWeight: 500, marginLeft: '0.2rem', marginRight: '0.2rem' }}>
            {startDate}
        </span>
        by
        <span style={{ fontWeight: 500, marginLeft: '0.2rem', marginRight: '0.2rem' }}>
            {submitter}
        </span>
    </div>
);

const DataSourceModal = ({
    showDataSourceModal, reportList, dataSourceReport, dataSourceReportId,
    setDataSourceReportId, dataSourceReportPeriod, setDataSourceReportPeriod,
    onDataSourceCancel, onSaveDataSource, isDataAvailableInRuleEngine,
    onFileExplorerClicked, batchList, dataSourceBatchId, setDataSourceBatchId,
    tenantId, showAddFilesModal, assignDataSourceLoading,
    onFileExplorerClosed, setDataSourceFileId, reportSourceLoading, currentSourceFileName,
    onDownloadTemplate, downloadTemplateLoading, isFileCurrentSource,
    setIsFileCurrentSource, setDataSourceFileName, setDisableSaveButton, disableSaveButton,
}) => {
    const fileExplorerClassName = isFileCurrentSource
        ? 'appkiticon icon-folder-opened-outline file-explorer-active'
        : 'appkiticon icon-folder-opened-outline file-explorer-inactive';
    const ruleEngineClassName = !isFileCurrentSource
        ? 'font-weight-medium rule-engine-active' : 'rule-engine-inactive';

    if (showAddFilesModal) {
        return (
            <AddFilesModal
                visible={showAddFilesModal}
                onFileExplorerClosed={onFileExplorerClosed}
                tenantId={tenantId}
                setDataSourceFileId={setDataSourceFileId}
                setDataSourceBatchId={setDataSourceBatchId}
                assignDataSourceLoading={assignDataSourceLoading}
                setDataSourceFileName={setDataSourceFileName}
            />
        );
    }
    if (showDataSourceModal) {
        return (
            <>
                <Modal
                    className="action-modal-showcase"
                    visible={showDataSourceModal}
                    onCancel={() => onDataSourceCancel()}
                    style={{ width: '600px' }}
                    backdropClosable={false}
                >
                    <ModalHeader>
                        <div className="a-modal-example-header">
                            <div className="modal-title-left">
                                <div className="modal-title">DATA SETUP SOURCE</div>
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md={12}>
                                <div className="a-h6" style={{ margin: '0.5rem' }}>Select Report</div>
                                <Select
                                    value={dataSourceReportId}
                                    placeholder="Select Report"
                                    showSearchOnList
                                    onSelect={value => {
                                        setDataSourceReportId(value);
                                    }}
                                >
                                    {
                                        reportList && reportList.map(({ id, name }) => (
                                            <SelectOption key={id} value={id}>{name}</SelectOption>
                                        ))
                                    }
                                </Select>
                            </Col>
                        </Row>
                        {dataSourceReport && dataSourceReport.hasPeriod && (
                            <Row>
                                <Col md={12}>
                                    <div className="a-h6" style={{ margin: '0.5rem' }}>Select Period</div>
                                    <Select
                                        value={dataSourceReportPeriod}
                                        placeholder="Select Period"
                                        onSelect={value => {
                                            setDataSourceReportPeriod(value);
                                        }}
                                    >
                                        {
                                            dataSourceReport.periodData && dataSourceReport.periodData.map(({ label, period }) => (
                                                <SelectOption key={period} value={period}>{label}</SelectOption>
                                            ))
                                        }
                                    </Select>
                                </Col>
                            </Row>
                        )}
                        <Row>
                            <Col md={12}>
                                {dataSourceReport && isDataAvailableInRuleEngine !== null && !reportSourceLoading && (
                                    <>
                                        <div className="a-h6" style={{ margin: '0.5rem', paddingTop: '0.5rem' }}>Select Data Source</div>
                                        <div className="risk-detect-reg-reporting-cross-report-data-source-action-container">
                                            <div style={{ margin: '1rem', textAlign: 'center' }}>
                                                <span
                                                    className={ruleEngineClassName}
                                                    style={{
                                                        margin: '0.25rem',
                                                        fontSize: '0.85rem',
                                                        textAlign: 'center',
                                                        cursor: !isFileCurrentSource ? 'pointer' : 'default',
                                                    }}
                                                >
                                                    Select batch from Rule Engine
                                                </span>
                                                <span style={{ padding: '0.5rem' }}>
                                                    <Switch
                                                        size="small"
                                                        checked={isFileCurrentSource}
                                                        disabled={!isDataAvailableInRuleEngine}
                                                        onChange={() => {
                                                            setIsFileCurrentSource(!isFileCurrentSource);
                                                            setDisableSaveButton(true);
                                                        }}
                                                    />
                                                </span>
                                                <span className={fileExplorerClassName}>
                                                    <span
                                                        className="font-weight-medium text-nowrap"
                                                        style={{
                                                            margin: '0.5rem',
                                                            fontSize: '0.85rem',
                                                            cursor: isFileCurrentSource ? 'pointer' : 'default',
                                                        }}
                                                        onClick={onFileExplorerClicked}
                                                        role="presentation"
                                                    >
                                                        Select from File Explorer
                                                    </span>
                                                </span>
                                            </div>
                                            {!isFileCurrentSource && (
                                                <div>
                                                    <Select
                                                        value={dataSourceBatchId}
                                                        placeholder="Select Batch"
                                                        showSearchOnList
                                                        onSelect={value => {
                                                            setDataSourceBatchId(value);
                                                            setDataSourceFileId(null);
                                                            setDisableSaveButton(false);
                                                        }}
                                                    >
                                                        {
                                                            batchList && batchList.map(({ batchId, startDate, submitter }) => (
                                                                <SelectOption key={batchId} value={batchId}>{getBatchSelectOptions(batchId, startDate, submitter)}</SelectOption>
                                                            ))
                                                        }
                                                    </Select>
                                                </div>
                                            )}
                                            {isFileCurrentSource && (
                                                <>
                                                    <div
                                                        className="risk-detect-reg-reporting-cross-report-data-source-action-container-header"
                                                    >
                                                        {currentSourceFileName && (
                                                            <div
                                                                style={{ fontSize: '0.8rem' }}
                                                            >
                                                                <p>
                                                                    {`Current File Name: ${currentSourceFileName}`}
                                                                </p>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div
                                                        className="risk-detect-reg-reporting-cross-report-data-source-action-container-header__icons-section"
                                                    >
                                                        <Button
                                                            size="sm"
                                                            kind="secondary"
                                                            disabled={reportSourceLoading}
                                                            onClick={onDownloadTemplate}
                                                            isLoading={downloadTemplateLoading}
                                                        >
                                                            Download Template
                                                        </Button>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </>
                                )}
                                {reportSourceLoading && (
                                    <>
                                        <div className="a-h6" style={{ margin: '0.5rem', paddingTop: '0.5rem' }}>Select Data Source</div>
                                        <div className="data-source-action-container">
                                            <Loader />
                                        </div>
                                    </>
                                )}
                            </Col>
                        </Row>
                        <div className="button-comp">
                            <Button kind="secondary" gray onClick={() => { onDataSourceCancel(); }} size="lg"> Cancel </Button>
                            <Button
                                kind="primary"
                                onClick={onSaveDataSource}
                                size="lg"
                                isLoading={assignDataSourceLoading}
                                disabled={disableSaveButton}
                            >
                                Save
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>
            </>
        );
    }
    return null;
};

export default DataSourceModal;
